/**
 * UI Selectors/Helpers
 */

import { createSelector } from 'reselect';

type UIComponent = 'trackDetails' | 'addToProject';

export const getUIState = ({ ui }: IStoreState) => ui;

export const getTrackDetailsTrackInfo = createSelector(
  getUIState,
  ({ trackDetails }) => {
    if (trackDetails && trackDetails.trackInfo) {
      return trackDetails.trackInfo;
    }
    return undefined;
  },
);

export const getAddToProjectTrackId = createSelector(
  getUIState,
  ({ addToProject }) => {
    if (addToProject && addToProject.trackId) {
      return addToProject.trackId;
    }
    return undefined;
  },
);

export const uiComponentIsVisible = (component: UIComponent) => createSelector(
  getUIState,
  (state) => {
    const Component = state[component];
    return !!Component && Component.visible;
  },
);

export const trackDetailsPanelIsVisible = uiComponentIsVisible('trackDetails');
export const addToProjectPanelIsVisible = uiComponentIsVisible('addToProject');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/selectors/ui.ts